import { render, staticRenderFns } from "./OffBoardingPersonInfo.vue?vue&type=template&id=4b3fcb84&scoped=true&"
import script from "./OffBoardingPersonInfo.vue?vue&type=script&lang=js&"
export * from "./OffBoardingPersonInfo.vue?vue&type=script&lang=js&"
import style0 from "./OffBoardingPersonInfo.vue?vue&type=style&index=0&id=4b3fcb84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3fcb84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VCol,VContainer,VForm,VRow,VSelect,VSpacer,VTextField})
